/**
 * Cálculos de apresentação do Feed Joga Junto, transcritos do Rede Joga Junto.dc.html.
 * Funções puras sobre o dado que a API já entrega.
 */
import { FormatNumber } from 'utils/helpers';
import { MoedaLabel } from 'utils/strings';

/** Funcis por página na grade de participantes. */
export const POR_PAGINA = 9;

const CORES_DOS_FUNCIS = [
  'bg-brand-purple-light',
  'bg-brand-green',
  'bg-brand-pink-light',
  'bg-brand-yellow',
  'bg-brand-cyan-light',
  'bg-brand-green-light',
];

/** "ABDALLA LIMA" → "AL"; "LEONARDO" → "L" (duas primeiras palavras, como no design). */
export function iniciaisDoFunci(nomeDeGuerra?: string): string {
  return (nomeDeGuerra ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(palavra => palavra[0])
    .join('')
    .toUpperCase();
}

/** "Adê Mire Ribeiro" → "AR" (primeira e última palavra, como nos cartões de realização do design). */
export function iniciaisDoNomeCompleto(nome?: string): string {
  const palavras = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  if (palavras.length < 2) return iniciaisDoFunci(nome);

  return `${palavras[0][0]}${palavras[palavras.length - 1][0]}`.toUpperCase();
}

/** Cor do círculo de iniciais pela posição do funci na lista completa. */
export function corDoFunci(posicao: number): string {
  return CORES_DOS_FUNCIS[posicao % CORES_DOS_FUNCIS.length];
}

export function rotuloDoResultado(total: number): string {
  return total === 1 ? 'funci encontrado' : 'funcis encontrados';
}

export function estatisticasDoPerfil(reconhecimentos: unknown[], realizacoes: { total?: number }[]) {
  const pontos = realizacoes.reduce((soma, item) => soma + (item.total ?? 0), 0);

  return {
    reconhecimentos: reconhecimentos.length,
    realizacoes: realizacoes.length,
    pontos: String(FormatNumber(pontos, false)),
  };
}

const COR_POR_STATUS: Record<string, string> = {
  aguardando: 'bg-brand-pink-light',
  aprovado: 'bg-brand-cyan-light',
  promovido: 'bg-brand-cyan-light',
  dobrado: 'bg-brand-green',
  valeu: 'bg-brand-green',
  mandou: 'bg-brand-green',
  selo: 'bg-brand-yellow',
};

/** Cor do chip de status da realização; status fora do design ficam em cinza neutro. */
export function corDoStatus(status?: string): string {
  return (status && COR_POR_STATUS[status]) || 'bg-surface-200';
}

const MESES = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'];

/** "12 ago. 2026 · 14:32", como nos reconhecimentos do design. */
export function dataCompleta(time: number | string): string {
  const data = new Date(time);
  const hora = `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;

  return `${data.getDate()} ${MESES[data.getMonth()]} ${data.getFullYear()} · ${hora}`;
}

/** "uau" → "#UAU"; moeda ausente vira texto vazio, para o chip omitir a parte. */
export function rotuloDaMoeda(coin?: string): string {
  return (coin && MoedaLabel[coin]) || '';
}

const COR_DA_MOEDA: Record<string, string> = { '#UAU': 'bg-brand-yellow', '#MANDOUBEM': 'bg-brand-cyan-light', '#VALEU': 'bg-brand-purple-light' };

/**
 * Fundo do chip de moeda nos cartões de reconhecimento do prefixo, como no design. Recebe o
 * rótulo que a Home já calcula (`RecentRecognition.level`, HOME-19).
 */
export function corDaMoeda(rotulo?: string): string {
  return (rotulo && COR_DA_MOEDA[rotulo]) || '';
}
